import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { DataService } from "src/app/shared/Services/data.service";
import { GetCurrentShift } from "src/app/shared/Services/getCurrentShift";
import pdfMake from "pdfmake/build/pdfMake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";


@Component({
  selector: "app-partwise-report",
  templateUrl: "./partwise-report.component.html",
  styleUrls: ["./partwise-report.component.scss"],
  animations: [
    trigger("detailExpand", [
      state(
        "collapsed",
        style({ height: "0px", minHeight: "0", visibility: "hidden" })
      ),
      state("expanded", style({ height: "*", visibility: "visible" })),
      transition("expanded <=> collapsed", animate("500ms ease-in-out")),
    ]),
  ],
})
export class PartwiseReportComponent implements OnInit {
    private cancelPreviousRequests$ = new Subject<void>();
  userDetails: any;
  custId: string;
  timezone: string;
  custName: string;
  mailform!: FormGroup;

  departmentData: any[] = [];
  selectedDepartment!: string;
  breadCrumbItems: { label: string; active?: boolean }[] = [];

  selectedDepartmentId!: string;
  selectedDepartmentShift: any[] = [];
  shiftData: any[] = [];
  selectedShift!: string;
  selectedShiftId!: string;

  currentShiftData: any;
  maxdate!: string;
  fromDate!: string;
  toDate!: string;
  mindate!: string;

  base64String: string = "";
  tablehourlyData: any[] = [];

  machineData: any[] = [];
  filterMachine: any[] = [];
  selectedMachine!: string;
  selectedMachineId!: string;

  showTable: boolean = false;
  action!: string;
  pdfBool: boolean = false;
  csvBool: boolean = false;
  exportViaMail: boolean = false;
  itemsPerPage: number = 5;
  pageSize: number;
  currentPage: number = 1;

  selectedpart: string;
  tablepartData: any = [];
  partData: any = [];
  isPartdata: boolean = false;

  tableData: any = [];
  expandedRowIndex: number | null = null;

  availabilityChart: any;
  productionChart: any;
  hourlyproductionChart: any;
  selectedPartData: any = [];

  downtimeReasonData: any[] = [];
  filteredData: any[] = [];
  rejectionReasonData: any[] = [];
  commentData: any[] = [];
  commentfilteredData: any[] = [];

  rejectionfilteredData: any[] = [];
  downtimeitemsPerPage = 5;
  downtimepageSize;
  rejectionitemsPerPage = 5;
  rejectionpageSize;
  currencommenttPage=1
  commentitemsPerPage = 5;
  commentpageSize;
  currendowntimetPage = 1;
  currenrejectiontPage = 1;

  filters = {
    machineName: "",
    shiftName: "",
    status: "",
    reason: "",
    subreason: "",
    partName: "",
  };
  rejectionfilters = {
    machineName: "",
    shiftName: "",
    reason: "",
    partName: "",
  };
  commentfilters = {
    machineName: "",
    shiftId: "",
    operatorName: "",
  };
    machinecommentOptions: string[] = [];
  shiftcommentOptions: string[] = [];
  operatorcommentOptions: string[] = [];
  

  machineOptions: string[] = [];
  shiftOptions: string[] = [];
  statusOptions: string[] = [];
  reasonOptions: string[] = [];
  partOptions: string[] = [];

  subreasonOptions: string[] = [];

  machinerejectionOptions: string[] = [];
  shiftrejectionOptions: string[] = [];
  reasonrejectionOptions: string[] = [];
  partrejectionOptions: string[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private dataservice: DataService,
    private http: HttpClient,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private currShift: GetCurrentShift
  ) {
    const user = sessionStorage.getItem("currentUser");
    if (user) {
      this.userDetails = JSON.parse(user);
      this.custId = this.userDetails?.user?.custId;
      this.timezone = this.userDetails?.user?.timeZone;
      this.custName = this.userDetails?.user?.name;
    }
  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "K2" },
      { label: "Part Wise Reports", active: true },
    ];

    this.mailform = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });

    this.getDepartment();
    this.convertImageToBase64();
    this.getavailabilityChart(null);
    this.gethourlyproductionChart(null);
    this.getproductionChart(null);
    this.auditLogs()
  }

     auditLogs(){
    let obj = {
      custID : this.custId
    }
  
    this.dataservice
      .reportApi(
        "auditlog/partreport",
        obj
      ).subscribe(
          (res) => {
           
          },
          (error) => {
            this.toastr.error("Server Unreachable", error);
          }
        );
    }

  /** Convert logo to base64 string for reports */
  convertImageToBase64() {
    const imagePath = "assets/wimera/Wimera_Logo_wSlogan_Green.png";
    this.http.get(imagePath, { responseType: "blob" }).subscribe({
      next: (data: Blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.base64String = reader.result as string;
        };
        reader.readAsDataURL(data);
      },
      error: () => {
        this.toastr.error("Failed to load company logo");
      },
    });
  }

  /** Fetch department list */
  getDepartment() {
    this.departmentData = [];
    this.dataservice.get(`department?custId=${this.custId}`).subscribe({
      next: (res: any) => {
        if (res?.data?.length) {
          this.departmentData = res.data;

          this.selectedDepartment = this.departmentData[0].departmentName;
          this.selectedDepartmentId = this.departmentData[0].departmentId;
          this.selectedDepartmentShift = this.departmentData[0].shiftData;

          this.shiftData = [
            { shiftName: "All Shift" },
            ...this.selectedDepartmentShift,
          ];
          this.selectedShift = "All Shift";
          this.selectedShiftId = "All Shift";

          this.currentShiftData = this.currShift.getCurrentShift(
            this.selectedDepartmentShift,
            this.timezone
          );

          if (this.currentShiftData?.currentDate) {
            const today = moment(this.currentShiftData.currentDate)
              .subtract(1, "days")
              .format("YYYY-MM-DD");

            this.maxdate = today;
            this.fromDate = today;
            this.toDate = today;

            this.getMachines();
          }
        }
      },
      error: () => {
        this.toastr.error("Failed to fetch department data");
      },
    });
  }

  /** Department selection change */
  select_Department(value: string) {
    this.cancelPreviousRequests$.next();
    this.shiftData = [];
    const filter = this.departmentData.find((d) => d.departmentName === value);

    if (filter) {
      this.selectedDepartmentId = filter.departmentId;
      this.selectedDepartmentShift = filter.shiftData;

      this.shiftData = [
        { shiftName: "All Shift" },
        ...this.selectedDepartmentShift,
      ];
      this.selectedShift = "All Shift";
      this.selectedShiftId = "All Shift";

      this.currentShiftData = this.currShift.getCurrentShift(
        this.selectedDepartmentShift,
        this.timezone
      );

      if (this.currentShiftData?.currentDate) {
        const today = moment(this.currentShiftData.currentDate)
          .subtract(1, "days")
          .format("YYYY-MM-DD");

        this.maxdate = today;
        this.fromDate = today;
        this.toDate = today;

        this.getMachines();
      }
    }
  }

  /** Shift selection change */
  select_Shift(shiftName: string) {
      this.cancelPreviousRequests$.next();
    this.tablehourlyData = [];
    this.selectedShift = shiftName;

    if (shiftName !== "All Shift") {
      const filtershift = this.selectedDepartmentShift.find(
        (s) => s.shiftName === shiftName
      );
      this.selectedShiftId = filtershift?.usershiftId || "";
    } else {
      this.selectedShiftId = "All Shift";
    }

    this.getPartData();
  }

  /** Date selection change */
  select_Date(date: string) {
    this.cancelPreviousRequests$.next();
    this.fromDate = date;
    this.toDate = date;
    this.getPartData();
  }

  /** Fetch machine list */
  getMachines() {
    this.machineData = [];
    this.filterMachine = [];

    this.dataservice.get(`api/device?custId=${this.custId}`).subscribe({
      next: (res: any) => {
        if (res?.length) {
          this.machineData = res;
          this.filterMachine = this.machineData.filter(
            (m) => m.departmentName === this.selectedDepartment
          );

          if (this.filterMachine.length) {
            this.selectedMachine = this.filterMachine[0].deviceName;
            this.selectedMachineId = this.filterMachine[0].deviceId;

            this.getPartData();
          }
        }
      },
      error: () => {
        this.toastr.error("Failed to fetch machines");
      },
    });
  }

  /** Machine selection change */
  select_Machine(deviceName: string) {
      this.cancelPreviousRequests$.next();
    this.tablehourlyData = [];
    this.selectedMachine = deviceName;

    const filter = this.machineData.find((m) => m.deviceName === deviceName);
    this.selectedMachineId = filter?.deviceId || "";

    this.getPartData();
  }

  /** Fetch part data */
  getPartData() {
      this.cancelPreviousRequests$.next();
    const param = {
      custId: this.custId,
      department: this.selectedDepartment,
      departmentId:this.selectedDepartmentId,
      date: this.fromDate,
      usershiftId: this.selectedShiftId,
      deviceId: this.selectedMachineId,
    };

    this.isPartdata = false; // reset before call
    this.toastr.info("Please wait while fetching record...");

    
    this.dataservice
      .reportApi(
        "reports/parts",
       param
      ).subscribe({
      next: (res: any) => {
        if (res && Object.keys(res).length > 0) {
          this.isPartdata = true;
          this.tablepartData = res;
          this.partData = [{ partName: "All Part" }, ...this.tablepartData];
          this.selectedpart = "All Part";
          this.getData();
        } else {
          this.showTable = false;
          this.tableData = []
          this.isPartdata = false;
          this.toastr.warning("No data available for the selected Date");
          this.getavailabilityChart(null);
          this.gethourlyproductionChart(null);
          this.getproductionChart(null);
        }
      },
      error: (err) => {
        this.showTable = false;
        this.tableData = []
        this.getavailabilityChart(null);
        this.gethourlyproductionChart(null);
        this.getproductionChart(null);
        this.isPartdata = false;
        this.toastr.error("Failed to fetch part data");
      },
    });
  }

  select_part(partName: string) {
    this.selectedpart = partName;
    this.getData();
  }

  hasPin2:boolean;
  getData() {
    this.rejectionfilteredData = []
    this.commentfilteredData=[]
    this.downtimeReasonData = []
    this.tableData = []
    const param = {
      custId: this.custId,
      department: this.selectedDepartment,
      date: this.fromDate,
      usershiftId: this.selectedShiftId,
      deviceId: this.selectedMachineId,
      departmentId:this.selectedDepartmentId,
      partName: this.selectedpart,
    };

    this.toastr.info("Please wait while fetching record...");
    this.dataservice.reportApi("reports/partProduction",param).pipe(takeUntil(this.cancelPreviousRequests$)).subscribe({
      next: (res: any) => {
        if (res && Object.keys(res).length > 0) {
          this.showTable = true;
          this.tableData = res['tabledata']
          this.hasPin2 = this.tableData?.['hourlyData'][0].hasOwnProperty('pin2Count') ?? false;

          if (this.tableData?.["downtimeReasonData"]?.length) {
            this.downtimeReasonData = this.tableData["downtimeReasonData"];
            this.filteredData = [...this.downtimeReasonData];

            this.machineOptions = [
              ...new Set(this.downtimeReasonData.map((d) => d.machineName)),
            ];
            this.shiftOptions = [
              ...new Set(this.downtimeReasonData.map((d) => d.shiftName)),
            ];
            this.statusOptions = [
              ...new Set(this.downtimeReasonData.map((d) => d.status)),
            ];
            this.reasonOptions = [
              ...new Set(this.downtimeReasonData.map((d) => d.reason)),
            ];
            this.subreasonOptions = [
              ...new Set(this.downtimeReasonData.map((d) => d.subreason)),
            ];
            this.partOptions = [
              ...new Set(this.downtimeReasonData.map((d) => d.partName)),
            ];
          }else{
            this.downtimeReasonData=[]
            this.filteredData=[]
          }
          if (this.tableData?.["rejectionReasonData"]?.length) {
            this.rejectionReasonData = this.tableData["rejectionReasonData"];
            this.rejectionfilteredData = [...this.rejectionReasonData];

            this.machinerejectionOptions = [
              ...new Set(this.rejectionReasonData.map((d) => d.machineName)),
            ];
            this.shiftrejectionOptions = [
              ...new Set(this.rejectionReasonData.map((d) => d.shiftName)),
            ];
            this.reasonrejectionOptions = [
              ...new Set(this.rejectionReasonData.map((d) => d.reason)),
            ];
            this.partrejectionOptions = [
              ...new Set(this.rejectionReasonData.map((d) => d.partName)),
            ];
          }else{
            this.rejectionReasonData = [];
            this.rejectionfilteredData = [];

          }
          if (this.tableData?.["commentData"]?.length) {
            this.commentData = this.tableData["commentData"];
            this.commentfilteredData = [...this.commentData];

            this.machinecommentOptions = [
              ...new Set(this.commentData.map((d) => d.machineName)),
            ];
            this.shiftcommentOptions = [
              ...new Set(this.commentData.map((d) => d.shiftId)),
            ];
            this.operatorcommentOptions = [
              ...new Set(this.commentData.map((d) => d.operatorName)),
            ];
          
          }else{
             this.commentData = [];
            this.commentfilteredData = [];
          }
          this.getavailabilityChart(this.tableData["partData"]);
          this.gethourlyproductionChart(this.tableData["hourlyProductionData"]);
          this.getproductionChart(this.tableData["partData"]);
        } else {
          this.showTable = false;
          this.toastr.warning("No data available for the selected Date");
        }
      },
      error: (err) => {
        this.showTable = false;
        this.toastr.error("Failed to fetch part data");
      },
    });
  }

  applyFilters() {
    this.filteredData = this.downtimeReasonData.filter((item) => {
      return (
        (!this.filters.machineName ||
          item.machineName === this.filters.machineName) &&
        (!this.filters.shiftName ||
          item.shiftName === this.filters.shiftName) &&
        (!this.filters.status || item.status === this.filters.status) &&
        (!this.filters.reason || item.reason === this.filters.reason) &&
        (!this.filters.subreason ||
          item.subreason === this.filters.subreason) &&
        (!this.filters.partName || item.partName === this.filters.partName)
      );
    });
  }

  applyrejectionFilters() {
    this.rejectionfilteredData = this.rejectionReasonData.filter((item) => {
      return (
        (!this.rejectionfilters.machineName || item.machineName === this.rejectionfilters.machineName) &&
        (!this.rejectionfilters.shiftName || item.shiftName === this.rejectionfilters.shiftName) &&
        (!this.rejectionfilters.reason || item.reason === this.rejectionfilters.reason) &&
        (!this.rejectionfilters.partName || item.partName === this.rejectionfilters.partName)
      );
    });
  }
  applycommentFilters() {
    this.commentfilteredData = this.commentData.filter((item) => {
      return (
        (!this.commentfilters.machineName || item.machineName === this.commentfilters.machineName) &&
        (!this.commentfilters.shiftId || item.shiftId === this.commentfilters.shiftId) &&
        (!this.commentfilters.operatorName || item.operatorName === this.commentfilters.operatorName)
      );
    });
  }

  getavailabilityChart(data: any) {
    if (!data || data.length === 0) {
      this.availabilityChart = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: {
            color: "#999",
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }
    this.availabilityChart = {
      title: {
        text: "OEE",
        textStyle: { fontSize: 12, color: "#333" },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333", fontSize: 12 },
        formatter: function (params) {
          // params is an array of series data at the hovered point
          let tooltipText = `<b>${params[0].axisValue}<br/>`;

          params.forEach((item) => {
            tooltipText += `
        <span style="
          display:inline-block;
          margin-right:5px;
          border-radius:50%;
          width:9px;
          height:9px;
          background-color:${item.color};
        "></span>
        <span>${item.seriesName}: ${item.value}%</span><br/>
      `;
          });

          return tooltipText;
        },
      },
      legend: {
        top: 15,
        show: true,
        orient: "horizontal",
        left: "center",
        textStyle: { fontSize: 11 },
        itemWidth: 10,
        itemHeight: 10,
        data: ["Availability", "Performance", "Quality", "Oee"],
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "5%",
        containLabel: true,
      },
      xAxis: {
        name: "Parts",
        type: "category",
        nameLocation: "middle",
        nameGap: 21,
        data: data.map((el) => el.partName),
      },
      yAxis: {
        name: "%",
        type: "value",
      },
      series: [
        {
          name: "Availability",
          type: "bar",
          itemStyle: { color: "#4CAF50" }, // green
          label: {
            show: true,
            position: "top",
            formatter: "{c}%",
            color: "#000",
            fontSize: 12,
          },
          data: data.map((el) => el.availability),
        },
        {
          name: "Performance",
          type: "bar",
          itemStyle: { color: "#FF9800" }, // orange
          label: {
            show: true,
            position: "top",
            formatter: "{c}%",
            color: "#000",
            fontSize: 12,
          },
          data: data.map((el) => el.performance),
        },
        {
          name: "Quality",
          type: "bar",
          itemStyle: { color: "#2196F3" }, // blue
          label: {
            show: true,
            position: "top",
            formatter: "{c}%",
            color: "#000",
            fontSize: 12,
          },
          data: data.map((el) => el.quality),
        },
        {
          name: "Oee",
          type: "bar",
          itemStyle: { color: "#9C27B0" }, // purple
          label: {
            show: true,
            position: "top",
            formatter: "{c}%",
            color: "#000",
            fontSize: 12,
          },
          data: data.map((el) => el.oee),
        },
      ],
    };
  }

  getproductionChart(data: any) {
    if (!data || data.length === 0) {
      this.productionChart = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: {
            color: "#999",
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }

    this.productionChart = {
      title: {
        text: "Part Production",
        textStyle: { fontSize: 12, color: "#333" },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333", fontSize: 12 },
        formatter: function (params) {
          // params is an array of series data at the hovered point
          let tooltipText = `<b>${params[0].axisValue}<br/>`;

          params.forEach((item) => {
            tooltipText += `
        <span style="
          display:inline-block;
          margin-right:5px;
          border-radius:50%;
          width:9px;
          height:9px;
          background-color:${item.color};
        "></span>
        <span>${item.seriesName}: ${item.value}</span><br/>
      `;
          });

          return tooltipText;
        },
      },
      legend: {
        top: 15,
        show: true,
        orient: "horizontal",
        left: "center",
        textStyle: { fontSize: 11 },
        itemWidth: 10,
        itemHeight: 10,
      },
      grid: {
        left: "5%",
        right: "4%",
        bottom: "5%",
        containLabel: true,
      },
      xAxis: {
        name: "Parts",
        nameLocation: "middle",
        nameGap: 21,
        type: "category",
        data: data.map((el) => el.partName),
      },
      yAxis: {
        type: "value",
        name: "count",
        nameLocation: "middle",
        nameGap: 45,
        axisLine: {
          lineStyle: {
            color: "#333",
          },
        },
      },
      series: [
        {
          name: "Planned",
          type: "bar",
          label: {
            show: true,
            position: "top",
          },
          data: data.map((el) => el.planned),
        },
        {
          name: "Produced",
          type: "bar",
          label: {
            show: true,
            position: "top",
          },
          data: data.map((el) => el.produced),
        },
        {
          name: "Rejected",
          type: "bar",
          label: {
            show: true,
            position: "top",
          },
          data: data.map((el) => el.rejected),
        },
      ],
    };
  }

  gethourlyproductionChart(data: any) {
    if (!data || data.length === 0 || data.parts.length === 0) {
      this.hourlyproductionChart = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: {
            color: "#999",
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }
    const hours = data.hours;

    // helper: sum all arrays across parts
    function sumArrays(arrays: number[][]): number[] {
      return arrays[0]?.map((_, i) =>
        arrays.reduce((sum, arr) => sum + (arr[i] || 0), 0)
      );
    }

    // dynamically collect planned, produced, rejected across all parts
    const planned = sumArrays(data.parts.map((p) => p.planned));
    const produced = sumArrays(data.parts.map((p) => p.produced));
    const rejected = sumArrays(data.parts.map((p) => p.rejected));

    // chart options
    this.hourlyproductionChart = {
      title: {
        text: "HOURLY PRODUCTION",
        textStyle: { fontSize: 12, color: "#333" },
      },
      tooltip: {
        trigger: "axis",
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333", fontSize: 12 },
        formatter: function (params) {
          const hour = params[0]?.axisValue ?? "";
          const index = hours.indexOf(hour);
          let tooltipHtml = `<div style="font-weight:bold; margin-bottom:5px;">${hour}</div>`;
          data.parts.forEach((part) => {
            tooltipHtml += `<div style="margin-bottom:4px;"><b>${part.partName}</b></div>`;
            params.forEach((p) => {
              if (!p) return;
              if (p.seriesName === "Planned") {
                tooltipHtml += `<div>${p.marker} Planned: ${part.planned[index]}</div>`;
              }
              if (p.seriesName === "Produced") {
                tooltipHtml += `<div>${p.marker} Produced: ${part.produced[index]}</div>`;
              }
              if (p.seriesName === "Rejected") {
                tooltipHtml += `<div>${p.marker} Rejected: ${part.rejected[index]}</div>`;
              }
            });
            tooltipHtml += "<br/>";
          });
          return tooltipHtml;
        },
      },

      legend: {
        show: true,
        orient: "horizontal",
        left: "center",
        textStyle: { fontSize: 11 },
        itemWidth: 10,
        itemHeight: 10,
        top: 15,
        data: ["Planned", "Produced", "Rejected"],
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "5%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: hours,
        name: "Hour",
        nameLocation: "middle",
        nameGap: 15,
        axisLine: {
          lineStyle: {
            color: "#333",
          },
        },
        axisLabel: {
          rotate: 0,
          fontSize: 9,
          formatter: function (value) {
            return value.split(" - ")[1];
          },
        },
      },
      yAxis: {
        type: "value",
        name: "count",
        nameLocation: "middle",
        nameGap: 40,
        axisLine: {
          lineStyle: {
            color: "#333",
          },
        },
      },
      series: [
        {
          name: "Planned",
          type: "bar",
          data: planned,
          label: { show: true, position: "top", rotate:90,offset: [5, -10] },
        },
        {
          name: "Produced",
          type: "bar",
          data: produced,
          label: { show: true, position: "top", rotate:90,offset: [5, -10] },
        },
        {
          name: "Rejected",
          type: "bar",
          data: rejected,
          label: { show: true, position: "top", rotate:90,offset: [5, -10] },
        },
      ],
    };
  }

  toggleRow(index: number) {
    this.expandedRowIndex = this.expandedRowIndex === index ? null : index;
  }

  /** Export Pdf or CSV*/
  openModal(templatepdf: any, data: any, act: any) {
    this.action = act;
    this.modalService.open(templatepdf, { centered: true });
  }

  get email() {
    return this.mailform.get("email");
  }

  mailexport() {
    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = true;
  }

  directExpo() {
    this.exportViaMail = false;
    this.pdfBool = false;
    this.csvBool = false;
    this.mailform.reset();
  }

  isEmailInvalid() {
    return this.email.invalid && (this.email.dirty || this.email.touched);
  }

  ngOnDestroy() { }

  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }

  ondowntimePageChange(pageNum: number): void {
    this.downtimepageSize = this.downtimeitemsPerPage * (pageNum - 1);
  }

  onrejectionPageChange(pageNum: number): void {
    this.rejectionpageSize = this.rejectionitemsPerPage * (pageNum - 1);
  }
  oncommentPageChange(pageNum: number): void {
    this.commentpageSize = this.commentitemsPerPage * (pageNum - 1);
  }

  pdf() {
    this.pdfBool = true;
    this.csvBool = false;
  }

  csv() {
    this.csvBool = true;
    this.pdfBool = false;
  }

  cancel() {
    this.pdfBool = false;
    this.csvBool = false;
    this.mailform.reset();
    this.exportViaMail = false;
  }

  formatMinutesToHHMMSS(minutes: number): string {
    if (isNaN(minutes) || minutes < 0 || !isFinite(minutes)) {
      return "00:00:00";
    }
    const totalSeconds = Math.floor(minutes * 60);
    const hours = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
  }
  chartInstance: any;
  onChartInit(ec: any) {
    this.chartInstance = ec;
  }
  productionChartInstance: any;
  onProductionChartInit(ec: any) {
    this.productionChartInstance = ec;
  }
  hourproductionChartInstance: any;
  onHourProductionChartInit(ec: any) {
    this.hourproductionChartInstance = ec;
  }
  download() {
    if (!this.pdfBool && !this.csvBool) this.pdfBool = true;
    if (this.pdfBool && this.base64String !== undefined && !this.exportViaMail ) {
      const chartImage = this.chartInstance?.getDataURL({
        type: "png",
        pixelRatio: 2,
        backgroundColor: "#fff",
      });
      const productionChartImage = this.productionChartInstance?.getDataURL({
        type: "png",
        pixelRatio: 2,
        backgroundColor: "#fff",
      });
      const hourproductionChartImage = this.hourproductionChartInstance?.getDataURL({
        type: "png",
        pixelRatio: 2,
        backgroundColor: "#fff",
      });

      const reportDate = moment(this.fromDate).format("YYYY-MM-DD");
      const pdfName = `Part Wise Report ${reportDate}`;
      const today = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      const year = moment(new Date()).format("YYYY");

      const machineHeaderRow = [
        { text: "Hour", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Part Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Shift Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "From", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "To", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Duration", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Qty Planned", fillColor: "#007d79", bold: true, color: "#fff" },
        // { text: "Qty Produced", fillColor: "#007d79", bold: true, color: "#fff" },
        ...(this.hasPin2 ? [{ text: "Partcount 1", fillColor: "#007d79", bold: true, color: "#fff" },{ text: "Partcount 1", fillColor: "#007d79", bold: true, color: "#fff" }] : [{text: "Qty Produced", fillColor: "#007d79", bold: true, color: "#fff"}]),
        { text: "Qty Rejected", fillColor: "#007d79", bold: true, color: "#fff" },
      ];

      const machinedowntimeHeaderRow = [
        { text: "Part Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Shift Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Status", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Time", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Duration(hrs)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Reason", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "SubReason", fillColor: "#007d79", bold: true, color: "#fff" },
      ];

      const machinerejectionHeaderRow = [
        { text: "Part Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Shift Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Reason", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Count", fillColor: "#007d79", bold: true, color: "#fff" },
      ];
      const machinecommentHeaderRow = [
         { text: "Operator Name", fillColor: "#007d79", bold: true, color: "#fff" },
         { text: "Machine Name", fillColor: "#007d79", bold: true, color: "#fff" },
         { text: "Shift Name", fillColor: "#007d79", bold: true, color: "#fff" },
         { text: "Part Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Comment", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Time", fillColor: "#007d79", bold: true, color: "#fff" },
      ];

      const machineRows = this.tableData?.["hourlyData"]?.flatMap((h: any) => {
        if (!h.details || h.details.length === 0) {
          return [];
        }

        return h.details.map((m, index) => {
          return [
            index === 0
              ? {
                text: h.hour || "NA", rowSpan: h.details.length, alignment: "center",
                valign: "middle"
              }
              : {},
            m.partName || "NA",
            h.shift || "NA",
            m.fromTime || "00:00:00",
            m.toTime || "00:00:00",
            m.duration || "00:00:00",
            m.planned?.toString() ?? "0",
            // m.produced?.toString() ?? "0",
            ...(this.hasPin2 ? [(m?.pin1Count?.toString() ?? "0"),(m?.pin2Count?.toString() ?? "0")] : [(m?.pin1Count?.toString() ?? "0")]),

            m.rejected?.toString() ?? "0",
          ];
        });
      }) || [];

      const machinedowntimeRows = this.filteredData?.map((d) => [
        d.partName || "NA",
        d.shiftName || "NA",
        d.status || "NA",
        d.reason !== "Not Specified"
          ? `${d.fromTime || ""} - ${d.toTime || ""}`
          : "NA",
        d.duration || "NA",
        d.reason || "NA",
        d.subreason || "NA",
      ]) || [];

      const machinerejectionRows = this.rejectionfilteredData?.map((d) => [
        d.partName || "NA",
        d.shiftName || "NA",
        d.reason || "NA",
        d.count || "0",
      ]) || [];
      const machinecommentRows = this.commentfilteredData?.map((d) => [
        d.operatorName || "NA",
        this.selectedMachine || "NA",
        d.usershiftId || "NA",
        d.partName || "NA",
        d.commentText || "NA",
        d.createdAt || "NA",
      ]) || [];

      // === Build PDF content ===
      const pdfContent: any[] = [
        {
          columns: [
            {
              image: this.base64String,
              width: 140,
              height: 45,
              alignment: "left",
              margin: [-30, -28, 0, 0],
            },
          ],
        },
        {
          columns: [
            {
              text: "PART WISE REPORT",
              fontSize: 15,
              bold: true,
              alignment: "center",
              margin: [0, -35, 0, 0],
            },
          ],
        },
        {
          columns: [
            {
              text: `(Date :  ${reportDate})`,
              margin: [0, -10, 0, 0],
              fontSize: 10,
              bold: true,
              alignment: "center",
            },
          ],
        },
        {
          canvas: [
            {
              type: "line",
              lineColor: "#007d79",
              x1: -40,
              y1: 0,
              x2: 2000,
              y2: 0,
              lineWidth: 0.05,
            },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: `Customer Name: ${this.custName}`,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        {
          text: `Department: ${this.selectedDepartment}`,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        {
          text: `Machine: ${this.selectedMachine}`,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        {
          text: `Shift: ${this.selectedShift}`,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        {
          columns: [
            {
              image: chartImage,
              width: 550,
              margin: [0, 5, 10, 20],
            },
            {
              image: productionChartImage,
              width: 550,
              margin: [10, 5, 0, 20],
            },
          ],
        },
        {
          image: hourproductionChartImage,
          width: 1150,
          height: 150,
          margin: [0, 5, 10, 20],
        },
      ];

      if (machineRows.length > 0) {
        pdfContent.push(
          {
            text: "Production",
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 8],
          },
          {
            table: {
              headerRows: 1,
              widths: Array(9 + (this.hasPin2 ? 2 : 0)).fill("*"),
              body: [machineHeaderRow, ...machineRows],
            },
            layout: {
              fillColor: (rowIndex, node, columnIndex) => {
                if (rowIndex === 0) return "#007d79"; // header row stays green
                if (columnIndex === 0) return null;   // no color for Hour column
                return rowIndex % 2 === 0 ? "#9ef0f0" : "#d9fbfb"; // alternate colors for rest
              },
              hLineWidth: () => 0.1,
              vLineWidth: () => 0.1,
            },
            fontSize: 8,
            margin: [0, 0, 0, 10],
          }
        );
      }

      if (machinedowntimeRows.length > 0) {
        pdfContent.push(
          {
            text: "Downtime Entry",
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 8],
          },
          {
            table: {
              headerRows: 1,
              widths: Array(7).fill("*"),
              body: [machinedowntimeHeaderRow, ...machinedowntimeRows],
            },
            layout: {
              fillColor: (i) =>
                i === 0 ? null : i % 2 === 0 ? "#9ef0f0" : "#d9fbfb",
              hLineWidth: () => 0.1,
              vLineWidth: () => 0.1,
            },
            fontSize: 8,
            margin: [0, 0, 0, 10],
          }
        );
      }

      if (machinerejectionRows.length > 0) {
        pdfContent.push(
          {
            text: "Rejection Entry",
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 8],
          },
          {
            table: {
              headerRows: 1,
              widths: Array(4).fill("*"),
              body: [machinerejectionHeaderRow, ...machinerejectionRows],
            },
            layout: {
              fillColor: (i) =>
                i === 0 ? null : i % 2 === 0 ? "#9ef0f0" : "#d9fbfb",
              hLineWidth: () => 0.1,
              vLineWidth: () => 0.1,
            },
            fontSize: 8,
            margin: [0, 0, 0, 10],
          }
        );
      }

      if (machinecommentRows.length > 0) {
        pdfContent.push(
          {
            text: "Operator Comment",
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 8],
          },
          {
            table: {
              headerRows: 1,
              widths: ["*", "*", "*", "*", 200, "*"], // commentText = index 4
              body: [machinecommentHeaderRow, ...machinecommentRows],
            },
            layout: {
              fillColor: (i) =>
                i === 0 ? null : i % 2 === 0 ? "#9ef0f0" : "#d9fbfb",
              hLineWidth: () => 0.1,
              vLineWidth: () => 0.1,
              defaultCell: { noWrap: false }, // allow wrapping
            },
            fontSize: 8,
            margin: [0, 0, 0, 10],
          }
        );
      }


      // === PDF Object ===
      const pdfObject = {
        pageSize: "A3",
        pageOrientation: "landscape",
        header: () => [
          {
            text: today,
            alignment: "right",
            margin: [0, 5, 20, 0],
            fontSize: 10,
          },
        ],
        footer: (currentPage, pageCount) => [
          {
            text: `Page ${currentPage} of ${pageCount}`,
            alignment: "center",
            fontSize: 7,
          },
          {
            text: `© ${year} Wimera Systems Pvt Ltd`,
            alignment: "right",
            fontSize: 7,
            margin: [5, 2, 10, 20],
          },
        ],
        content: pdfContent,
      };

      pdfMake.createPdf(pdfObject).download(`${pdfName}.pdf`);
    } else if (this.csvBool && !this.exportViaMail) {
      const masterData = this.tableData;
      const startDate = moment(this.fromDate).format("YYYY-MM-DD");

      // Start composing CSV content
      let csvContent = "";

      // Report Info
      csvContent += "PART WISE REPORT\n\n";
      csvContent += `Date: ${startDate}\n\n`;
      csvContent += `Department: ${this.selectedDepartment}\n\n`;
      csvContent += `Machine: ${this.selectedMachine}\n\n`;
      csvContent += `Shift: ${this.selectedShift}\n\n`;

      // === Production Table ===
      if (
        Array.isArray(masterData?.["hourlyData"]) &&
        masterData.hourlyData.length > 0
      ) {
        csvContent += "PRODUCTION\n";
        csvContent +=
          [
            "Hour",
            "Part Name",
            "Shift Name",
            "From",
            "To",
            "Duration",
            "Qty Planned",
            // "Qty Produced",
            ...(this.hasPin2 ? ["Part Count 1","Part Count 2"] : ["Qty Produced"]),
            "Qty Rejected",
          ].join(",") + "\n";

        (masterData?.["hourlyData"] ?? []).forEach((h: any) => {
          (h.details ?? []).forEach((m: any, index: number) => {
            csvContent +=
              [
                index === 0 ? h.hour || "NA" : "", // ✅ Print Hour once, rest empty
                m.partName || "NA",
                h.shift || "NA",
                m.fromTime || "00:00:00",
                m.toTime || "00:00:00",
                m.duration || "00:00:00",
                m.planned?.toString() ?? "0",
                // m.produced?.toString() ?? "0",
               ...(this.hasPin2 ? [(m?.pin1Count?.toString() ?? "0"),(m?.pin2Count?.toString() ?? "0")] : [(m?.pin1Count?.toString() ?? "0")]),
                m.rejected?.toString() ?? "0",
              ].join(",") + "\n";
          });
        });

        csvContent += "\n";
      }

      // === Downtime Table ===
      if (Array.isArray(this.filteredData) && this.filteredData.length > 0) {
        csvContent += "\nDOWNTIME DATA\n";
        csvContent +=
          [
            "Part Name",
            "Shift Name",
            "Status",
            "Time",
            "Duration(hrs)",
            "Reason",
            "SubReason",
          ].join(",") + "\n";

        this.filteredData.forEach((machine) => {
          csvContent +=
            [
              machine.partName || "",
              machine.shiftName || "",
              machine.status || "",
              machine.reason !== "Not Specified"
                ? `${machine.fromTime || ""} - ${machine.toTime || ""}`
                : "NA",
              machine.duration || "",
              machine.reason || "NA",
              machine.subreason || "NA",
            ].join(",") + "\n";
        });

        csvContent += "\n";
      }

      // === Rejection Table ===
      if (
        Array.isArray(this.rejectionfilteredData) &&
        this.rejectionfilteredData.length > 0
      ) {
        csvContent += "\nREJECTION DATA\n";
        csvContent += ["Part Name","Shift Name", "Reason", "Count"].join(",") + "\n";

        this.rejectionfilteredData.forEach((machine) => {
          csvContent +=
            [
              machine.partName || "",
              machine.shiftName || "",
              machine.reason || "",
              machine.count || "0",
            ].join(",") + "\n";
        });

        csvContent += "\n";
      }

       // === Operator Comment Table ===
      if (
        Array.isArray(this.commentfilteredData) &&
        this.commentfilteredData.length > 0
      ) {
        csvContent += "\nComment DATA\n";
        csvContent += ["Operator Name", "Machine Name","Shift Name", "Part Name", "Comment", "TIme"].join(",") + "\n";

        this.commentfilteredData.forEach((machine) => {
          csvContent +=
            [
              machine.operatorName || "",
              this.selectedMachine || "",
              machine.usershiftId || "",
              machine.partName || "",
              machine.commentText || "",
              machine.createdAt || "0",
            ].join(",") + "\n";
        });

        csvContent += "\n";
      }

      // === Trigger Download ===
      const encodedUri =
        "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `Partwise_Report_${startDate}.csv`);
      document.body.appendChild(link);
      link.click();

    } else if (this.pdfBool && this.exportViaMail) {
      let data = this.mailform.value;
      let maildata = {};
      (maildata["to"] = data["email"]),
        (maildata["partwiseData"] = this.tableData["hourlyData"]),
        (maildata["downtimeData"] = this.filteredData),
        (maildata["rejectionData"] = this.rejectionfilteredData),
        (maildata["commentData"] = this.commentfilteredData),
        (maildata["reportname"] = "partwiseReports"),
        (maildata["fromDate"] = this.fromDate),
        (maildata["customerName"] = this.custName),
        (maildata["departmentName"] = this.selectedDepartment),
        (maildata["machineName"] = this.selectedMachine),
        (maildata["shiftName"] = this.selectedShift),
        (maildata["filetype"] = "pdf");
      this.toastr.info("please wait while processing");
      this.dataservice.post("api/sendMail", maildata).subscribe(
        (res) => {
          this.toastr.success("Mail sent successfully!");
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    } else if (this.csvBool && this.exportViaMail) {
      let data = this.mailform.value;
      let maildata = {};
      (maildata["to"] = data["email"]),
        (maildata["partwiseData"] = this.tableData["hourlyData"]),
        (maildata["downtimeData"] = this.filteredData),
        (maildata["rejectionData"] = this.rejectionfilteredData),
        (maildata["commentData"] = this.commentfilteredData),
        (maildata["reportname"] = "partwiseReports"),
        (maildata["fromDate"] = this.fromDate),
        (maildata["customerName"] = this.custName),
        (maildata["departmentName"] = this.selectedDepartment),
        (maildata["machineName"] = this.selectedMachine),
        (maildata["shiftName"] = this.selectedShift),
        (maildata["filetype"] = "csv");
      this.toastr.info("please wait while processing");
      this.dataservice.post("api/sendMail", maildata).subscribe(
        (res) => {
          this.toastr.success("Mail sent successfully!");
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    }
    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = false;
    this.mailform.reset();
  }

}
